export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '13f9bbda-81a2-4e28-be86-030bbb1416bf';
export const MODAL_CLOSE_SEC = 2.5;
